<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" epub:type="pagebreak" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/chicorrigan0007#intro">Introduction: Bad Memories</a></p>
<p class="toc"><a class="xref" href="#/chicorrigan0008#ch01">1  Colonial Legacies</a></p>
<p class="toc"><a class="xref" href="#/chicorrigan0009#ch02">2  Trauma</a></p>
<p class="toc"><a class="xref" href="#/chicorrigan0010#ch03">3  Emotion</a></p>
<p class="toc"><a class="xref" href="#/chicorrigan0011#ch04">4  Forgetting and Remembering</a></p>
<p class="toc"><a class="xref" href="#/chicorrigan0012#ch05">5  Anxiety, Erasure, and Affect</a></p>
<p class="toc"><a class="xref" href="#/chicorrigan0013#ch06">6  Race, Religion, and Nation</a></p>
<p class="toc"><a class="xref" href="#/chicorrigan0014#conc">Conclusion: The Feeling of Forgetting</a></p>
<p class="tocbmf"><a class="xref" href="#/chicorrigan0015#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chicorrigan0016#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chicorrigan0018#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-corrigan-0006.vue?61cb9da0